module.exports = __webpack_public_path__ + "static/img/female-1.5ede07a6.png";